// extracted by mini-css-extract-plugin
export default {"mainLayout":"MainLayout_mainLayout__ZcZfi","pageContent":"MainLayout_pageContent__g1CMW","mainCollapsed":"MainLayout_mainCollapsed__dT15j","container":"MainLayout_container__D5FP9"};